import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../css/styles.css";
import {
    Box,
    Grid,
    TextField,
    CircularProgress,
    Snackbar,
    Alert
} from "@mui/material";
import { postCierreMesBroker } from "../../action";
import UploadExcel from "./UploadExcel";
import EditableTable from "./EditableTable";
import { parseExcelFile } from "../../services/excelService";
import { authHeader } from "../../utils/AuthHeader";

const CargaCierreMensual = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [excelData, setExcelData] = useState([]);
    const [mes, setMes] = useState("");
    const [version, setVersion] = useState(1);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const showMessage = (msg, sev = "info") => {
        setSnackbar({ open: true, message: msg, severity: sev });
    };

    const handleFileSelected = async (file) => {
        setLoading(true);
        setExcelData([]);
        try {
            const parsedData = await parseExcelFile(file);
            setExcelData(parsedData);
            showMessage("Archivo procesado exitosamente.", "success");
        } catch (error) {
            console.error(error);
            showMessage(error.message || "Ocurrió un error al procesar el archivo.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleDataChange = (newData) => {
        setExcelData(newData);
    };

    const handleGuardar = async () => {
        if (!mes) {
            showMessage("Debe seleccionar un mes.", "warning");
            return;
        }
        if (!version || version < 1) {
            showMessage("Debe ingresar una versión válida.", "warning");
            return;
        }
        if (excelData.length === 0) {
            showMessage("No hay datos para guardar.", "warning");
            return;
        }

        setSaving(true);
        try {
            const payloadData = excelData.map(({ id, ...rest }) => rest);

            const payload = {
                mes: mes,
                version: parseInt(version, 10),
                datos: payloadData
            };



            const config = {
                headers: {
                    Authorization: authHeader()
                }
            };

            const res = await dispatch(postCierreMesBroker(payload, config));
            showMessage("Datos guardados correctamente.", "success");

            setExcelData([]);
            setMes("");
            setVersion(1);

            setTimeout(() => {
                history.push("/cierre-mensual");
            }, 1000);

        } catch (error) {
            console.error("Error al guardar:", error);
            showMessage("Ocurrió un error al guardar los datos.", "error");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="contenido" style={{ minWidth: 0 , maxWidth: '100%' }}>
            <div className="header">
                <h2>Carga de Cierre Mensual</h2>
            </div>

            <Grid container spacing={4} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                        <TextField
                            label="Mes de Cierre"
                            type="month"
                            InputLabelProps={{ shrink: true }}
                            value={mes}
                            onChange={(e) => setMes(e.target.value)}
                            fullWidth
                            required
                            sx={{ bgcolor: 'white' }}
                        />
                        <TextField
                            label="Versión"
                            type="number"
                            InputProps={{ inputProps: { min: 1 } }}
                            value={version}
                            onChange={(e) => setVersion(e.target.value)}
                            fullWidth
                            required
                            sx={{ bgcolor: 'white' }}
                        />
                        <UploadExcel onFileSelected={handleFileSelected} isLoading={loading} />
                    </Box>
                </Grid>

                <Grid item xs={12} md={8}>
                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                            <CircularProgress />
                        </Box>
                    ) : excelData.length > 0 ? (
                        <Box>
                            <Box sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                justifyContent: "space-between",
                                alignItems: { xs: "stretch", sm: "flex-end" },
                                gap: 2,
                                mb: 2
                            }}>
                                <h3>Vista Previa ({excelData.length} registros)</h3>
                                <button
                                    className="boton"
                                    onClick={handleGuardar}
                                    disabled={saving}
                                >
                                    {saving ? "Guardando..." : "Confirmar y Guardar"}
                                </button>
                            </Box>
                            <EditableTable data={excelData} onDataChange={handleDataChange} />
                        </Box>
                    ) : (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200, border: "1px dashed #ccc", backgroundColor: "#fafafa" }}>
                            <div style={{ color: "text.secondary" }}>
                                Seleccione un archivo Excel para ver los datos.
                            </div>
                        </Box>
                    )}
                </Grid>
            </Grid>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div >
    );
};

export default CargaCierreMensual;
